import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { bindActionCreators } from 'redux'
import get from 'lodash/get'
import styled from 'styled-components'
import Sidebar from "react-sidebar"
import { Container, Row, Col } from 'reactstrap'

import { sidebarSelector } from '../../selectors'
import { authAction, sidebarAction } from '../../actions/'

import Header from '../header'
import SideBar from '../sidebar'
import "../../static/css/index.css"

const mql = window.matchMedia(`(min-width: 1281px)`)

class Layout extends React.Component {
  constructor(props) {
    super(props)

    this.props.setDocked(!mql.matches) // open sidebar follow screen size

    this.state = {
      transitions: false,
      shadow: true,
    }
  }
  componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged)
  }

  onSetSidebarOpen = (open) => { // this function control sidebar in mobile
    this.props.setDockedMobile(!open)
  }

  onSetOpen = (open) => {
    this.setState({ open })
  }

  mediaQueryChanged = () => {
    this.props.setDocked(!mql.matches)
  }

  toggleOpen = (ev) => {
    this.props.setDocked(!this.props.docked)
    if (ev) {
      this.setState({ transitions: true })
      ev.preventDefault()
    }
  }

  render() {
    const logout = () => {
      localStorage.clear()
      window.location = '/'
    }
    return (
      <LayoutCon fluid >
        <LayoutRow className="row no-gutters" >
          <SideBarCollapse // sidebar of webpage
            sidebar={ <SideBar /> }
            docked={ !this.props.docked }
            onSetOpen={ this.onSetOpen }
            shadow={ this.state.shadow }
            transitions={ this.state.transitions }
            styles={ {
              sidebar: { height: '100vh', width: '250px', backgroundColor: '#1A1A17' },
            } }
          >
            <HContentCon>
              { /* sidebar of mobile */ }
              <SideBarCollapse // sidebar of mobile
                sidebar={ <SideBar /> }
                open={ !this.props.docked_mobile }
                onSetOpen={ this.onSetSidebarOpen }
                styles={ {
                  sidebar: { height: '100vh', width: '50%', backgroundColor: "#CCCCCC", zIndex: 4 },
                } }
              >
                { /* */ }
              </SideBarCollapse>
              { /* sidebar of mobile */ }
              <Header
                onSetSidebarOpen={
                  () => this.onSetSidebarOpen(true)
                } // handle open sidebar of mobile
                onSetFullSidebarOpen={ (e) => this.toggleOpen(e) } // handle open sidebar desktop
                header={ get(this.props, 'location.state.header') }
                path={ get(this.props, 'location.pathname') }
                logout={ logout }
              />
              <ContentLayout>
                <Content>
                  {this.props.children}
                </Content>
              </ContentLayout>
            </HContentCon>
          </SideBarCollapse>
        </LayoutRow>
      </LayoutCon>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const mapStateToProps = createStructuredSelector({
  docked: sidebarSelector.getDocked,
  docked_mobile: sidebarSelector.getDockedMobile,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  logout: authAction.logout,
  setDocked: sidebarAction.setDocked,
  setDockedMobile: sidebarAction.setDockedMobile,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Layout)

const Content = styled.div`
  width: 100%;
  background-color: #F9F9F9;
    height: 100% ;
    overflow: hidden;
    @media (max-width: 575.98px) {
    height: 100vh ;
  }
  @media (max-width: 767.98px) {
    height: 100vh ;
  }
  @media (max-width: 991.98px) {
    height: 100vh ;
  }
`
const SideBarCollapse = styled(Sidebar).attrs({ children: '' })`
  overflow: hidden;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
`
const ContentLayout = styled.div`
  width: 100%;
  background-color: #F9F9F9;
  height: calc(100vh - 70px) ;
  position: relative ;
  overflow: hidden;
  @media (max-width: 575.98px) {
    height: calc(100vh - 50px) ;
  }
  @media (max-width: 767.98px) {
    height: calc(100vh - 50px) ;
  }
`
const LayoutCon = styled(Container)`
  height: 100% ;
  padding: 0 ;
  position: fixed ;
  overflow: hidden;
  @media (max-width: 575.98px) {
    height: 100vh;
    position: fixed ;
    top: 0;
  }
  @media (max-width: 767.98px) {
    height: 100vh;
    position: fixed ;
    top: 0;
  }
  @media (max-width: 991.98px) {
    height: 100vh;
    position: fixed ;
    top: 0;
  }
`
const HContentCon = styled(Col)`
  background-color: #F9F9F9;
  bottom : 0px ;
  position: relative ;
  padding: 0px;
  overflow: hidden;
`
const LayoutRow = styled(Row)`
  height: 100% ;
  bottom : 0px ;
  position: relative ;
  overflow: hidden;
  background-color: #F9F9F9;
`



// WEBPACK FOOTER //
// ./src/components/layout/index.js